import { render, staticRenderFns } from "./TestProvocativiEdit.vue?vue&type=template&id=5b76515c&scoped=true"
import script from "./TestProvocativiEdit.vue?vue&type=script&lang=js"
export * from "./TestProvocativiEdit.vue?vue&type=script&lang=js"
import style0 from "./TestProvocativiEdit.vue?vue&type=style&index=0&id=5b76515c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b76515c",
  null
  
)

export default component.exports